import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateRecommendationSuspendedMutationVariables = Types.Exact<{
  input: Types.CreateRecommendationSuspendedInput;
}>;


export type CreateRecommendationSuspendedMutationPage = { readonly __typename?: 'RootMutationType', readonly createRecommendationSuspended: { readonly __typename?: 'YalperRecommendationSuspended', readonly id: string, readonly sensorName: string, readonly suspendedUntil: string } };

export type DeleteRecommendationSuspendedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteRecommendationSuspendedMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteRecommendationSuspended: boolean };


export const CreateRecommendationSuspendedDocument = gql`
    mutation CreateRecommendationSuspended($input: CreateRecommendationSuspendedInput!) {
  createRecommendationSuspended(input: $input) {
    id
    sensorName
    suspendedUntil
  }
}
    `;
export type CreateRecommendationSuspendedMutationFn = Apollo.MutationFunction<CreateRecommendationSuspendedMutationPage, CreateRecommendationSuspendedMutationVariables>;

/**
 * __useCreateRecommendationSuspendedMutation__
 *
 * To run a mutation, you first call `useCreateRecommendationSuspendedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecommendationSuspendedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecommendationSuspendedMutation, { data, loading, error }] = useCreateRecommendationSuspendedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecommendationSuspendedMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecommendationSuspendedMutationPage, CreateRecommendationSuspendedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecommendationSuspendedMutationPage, CreateRecommendationSuspendedMutationVariables>(CreateRecommendationSuspendedDocument, options);
      }
export type CreateRecommendationSuspendedMutationHookResult = ReturnType<typeof useCreateRecommendationSuspendedMutation>;
export type CreateRecommendationSuspendedMutationResult = Apollo.MutationResult<CreateRecommendationSuspendedMutationPage>;
export type CreateRecommendationSuspendedMutationOptions = Apollo.BaseMutationOptions<CreateRecommendationSuspendedMutationPage, CreateRecommendationSuspendedMutationVariables>;
export const DeleteRecommendationSuspendedDocument = gql`
    mutation DeleteRecommendationSuspended($id: ID!) {
  deleteRecommendationSuspended(id: $id)
}
    `;
export type DeleteRecommendationSuspendedMutationFn = Apollo.MutationFunction<DeleteRecommendationSuspendedMutationPage, DeleteRecommendationSuspendedMutationVariables>;

/**
 * __useDeleteRecommendationSuspendedMutation__
 *
 * To run a mutation, you first call `useDeleteRecommendationSuspendedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecommendationSuspendedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecommendationSuspendedMutation, { data, loading, error }] = useDeleteRecommendationSuspendedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecommendationSuspendedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecommendationSuspendedMutationPage, DeleteRecommendationSuspendedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecommendationSuspendedMutationPage, DeleteRecommendationSuspendedMutationVariables>(DeleteRecommendationSuspendedDocument, options);
      }
export type DeleteRecommendationSuspendedMutationHookResult = ReturnType<typeof useDeleteRecommendationSuspendedMutation>;
export type DeleteRecommendationSuspendedMutationResult = Apollo.MutationResult<DeleteRecommendationSuspendedMutationPage>;
export type DeleteRecommendationSuspendedMutationOptions = Apollo.BaseMutationOptions<DeleteRecommendationSuspendedMutationPage, DeleteRecommendationSuspendedMutationVariables>;